/**
 * @module cx
 * @package @geenius/adapters/solidjs-css
 * @description Provides the lightweight class name composition helper used by
 * the SolidJS CSS variant. The helper keeps conditional CSS class assembly
 * terse without introducing Tailwind-specific dependencies.
 *
 * @param classes Class name strings where falsy values are ignored
 * @returns A space-delimited class name string containing only truthy values
 *
 * @example
 * ```ts
 * cx('button', 'button-primary') // 'button button-primary'
 * cx('button', isActive() && 'button-active') // 'button button-active' or 'button'
 * cx('base', null, undefined, false, 'modifier') // 'base modifier'
 * ```
 */
export function cx(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(" ");
}
